/**
 * BizForm — 사용자PC(/u/orders) 거래명세서/세금계산서(바이즈폼) 편집기.
 *
 * 하위 도메인
 * ───────────
 *   1) 사업자정보(내/상대) 목록·등록·수정      : get_myCo_DocList/getMyCoInfo/getOthereCoinfo/
 *                                                get_Other_DocList/make_DocList/checkBizTitle/
 *                                                add_Subject/make_BixForm/SaveCoDoc/getMyDocInfoSet/
 *                                                coinfosetClear/checkdefSetBizForm
 *   2) 폰트 설정                                : fontSetDig/fsSelect/selFontname/selFontsize/saveFontSet
 *   3) 거래명세서 내보내기                       : exportContract
 *
 * 도장은 stamp_img_id(이미지서버) 표시 전용이다. 옛 "내 도장" 선택 팝업(public/datas/stamps 목록)은
 * 생성기 폐기 후 저장에도 반영되지 않는 잔재라 제거했다.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-edit.js(721줄) 전역함수 23개를 이 클래스로 캡슐화했다(도장 선택 5개는 이후 제거 → 18개).
 * 호출처(bizform.php · bizform_otherform.inc.php 서버렌더 onclick · orders.blade · u-order-list.js ·
 * 자체 생성 onclick 문자열)가 전부 레거시 전역명을 사용하므로, $j.Pages.Desktop.Orders.initialize()
 * 가 모두 window 로 브리지해 전역 표면을 그대로 보존한다.
 *
 * ⚠ 결합 (페이지 완전 이관 시 정리 대상) — 모듈은 strict 이므로 전부 window.* 로 접근:
 *   - blade 전역   : window.my_co_Docs, window.other_co_Docs, window.ontractListOpenTab, window.manager_loginnum
 *   - 공유 전역     : window.coBoxCalTar (ContractAutocomplete 와 공유), window.orderTax
 *   - list.js 전역 : window.get_mem_ContactLists (ContractAutocomplete), window.bgcolorCh (onclick 문자열)
 *   - 공통 헬퍼     : window.int, window.render_template, window.swalert, $j(Ui.JBModal/Common.Store)
 *
 * 서버: /u/ajax/order-tax/{bizforms,bizform,bizform-link,save-contract}
 */
import Util from '../../../Common/Util';
export default class BizForm {
    constructor() {
        this._selMode = "";   // (구)coBizSelMode : "SELF" | "OTHER" (등록 대상 구분)
        this._calType = null; // (구)coBoxCalType : 목록 호출 타입 (레거시 잔재)
    }

    // ─────────────────────────────── 1) 사업자정보 ───────────────────────────────

    /** 내 사업자 목록 조회 (ajax) */
    get_myCo_DocList = (co_title) => {
        var adr = "/u/ajax/order-tax/bizforms";
        var sendData = { "getdoctype": "SELF", "user_no": window.manager_loginnum, "co_title": co_title };
        $.ajax({
            type: "GET", url: adr, data: sendData, success: (data) => {
                var myData = data.datas;
                if (typeof (myData) != "object") myData = [];
                window.my_co_Docs = myData;
                if (window.coBoxCalTar) this.getMyCoInfo(window.coBoxCalTar);
            }
        });
    }

    /** 내 사업자 목록 팝업 표시 */
    getMyCoInfo = (tar) => {
        window.coBoxCalTar = null;
        if (window.my_co_Docs == null) {
            window.coBoxCalTar = tar;
            this._calType = "SELF";
            this.get_myCo_DocList("");
            return;
        }
        var RT = tar.getBoundingClientRect();
        $('#Contract_DocTop').hide();
        document.getElementById("contractListSelASer").style.display = "none";
        var objTop = document.getElementById("contractListSelATop");
        var obj = document.getElementById("contractListSelA");
        if (objTop.style.display == "block" && window.ontractListOpenTab == 2) { objTop.style.display = "none"; return; }
        var ret;
        if (window.my_co_Docs.length > 0) {
            ret = this.make_DocList(window.my_co_Docs, "SELF");
        } else {
            ret = "등록 사업자없음. 추가 버튼 클릭해주세요";
        }
        obj.innerHTML = ret;
        objTop.style.width = parseInt(450) + "px";
        objTop.style.left = RT.left + "px";
        objTop.style.top = parseInt(RT.bottom + 3) + "px";
        objTop.style.display = "block";
        window.ontractListOpenTab = 2;
        document.getElementById("PPADD").style.display = "inline-block";
        document.getElementById("PPClose").style.width = "50%";
        this._selMode = "SELF";
    }

    /** 사업자 목록 검색 필터 */
    checkBizTitle = (tar) => {
        var obj = document.getElementById("contractListSelA");
        var inputs = obj.getElementsByTagName("div");
        var serKey = tar.value.trim();
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].id == "bizformea") {
                var skey = inputs[i].getAttribute("s_key");
                var stit = inputs[i].getAttribute("s_tit");
                var sco = inputs[i].getAttribute("s_co");
                if (serKey == "" || (skey == serKey || stit.indexOf(serKey) >= 0 || sco.indexOf(serKey) >= 0)) {
                    inputs[i].style.display = "block";
                } else {
                    inputs[i].style.display = "none";
                }
            }
        }
    }

    /** 사업자 목록 HTML 렌더 (내부) */
    make_DocList = (data, stype) => {
        var ret = "<div style='width:100%; height:5px'></div>";
        var func;
        stype == "SELF" ? func = 1 : func = 2;
        for (var i = 0; i < data.length; i++) {
            var chit = data[i];
            var row = {
                's_key': Util.escapeHtml(chit.s_key),
                'co_title': Util.escapeHtml(chit.co_title),
                'co_number': Util.escapeHtml(chit.co_number),
                'co_ceoname': Util.escapeHtml(chit.co_ceoname),
                'stype': stype,
                'rsno': chit.rsno,
                'i': i,
                'func': func
            };
            var tpl = `
            <div class='contserpopcp' id='bizformea' s_key='{s_key}' s_tit='{co_title}' s_co="{co_number}">
                <div style='display:inline-block; width:35%;text-align:left; padding:0px' class='contserpopcpin' onclick='getMyDocInfoSet("{i}","{func}")'>{co_number}</div>
                <div style='display:inline-block; width:30%;text-align:left; padding:0px' class='contserpopcpin' onclick='getMyDocInfoSet("{i}","{func}")'>{co_title}</div>
                <div style='display:inline-block; width:20%;text-align:left; padding:0px' class='contserpopcpin' onclick='getMyDocInfoSet("{i}","{func}")'>{co_ceoname}</div>
                <div style='display:inline-block; width:40px;' class='contserpopcpin' onclick="make_BixForm('{stype}', {rsno}, {i})">수정</div>
            </div>
            `;
            ret += Util.render_template(tpl, row);
        }
        ret += "<div style='width:100%; height:5px'></div>";
        return ret;
    }

    /** 상대 사업자 목록 팝업 표시 */
    getOthereCoinfo = (tar) => {
        window.coBoxCalTar = null;
        if (window.other_co_Docs == null) {
            window.coBoxCalTar = tar;
            this.get_Other_DocList("");
            return;
        }
        var RT = tar.getBoundingClientRect();
        document.getElementById("contractListSelASer").style.display = "none";
        var objTop = document.getElementById("contractListSelATop");
        var obj = document.getElementById("contractListSelA");
        $('#Contract_DocTop').hide();
        if (objTop.style.display == "block" && window.ontractListOpenTab == 3) { objTop.style.display = "none"; return; }
        var ret;
        if (window.other_co_Docs.length > 0) {
            if (window.other_co_Docs.length > 7) document.getElementById("contractListSelASer").style.display = "block";
            ret = this.make_DocList(window.other_co_Docs, "OTHER");
        } else {
            ret = "등록 사업자없음. 추가 버튼 클릭해주세요";
        }
        obj.innerHTML = ret;
        objTop.style.width = parseInt(450) + "px";
        objTop.style.left = RT.left + "px";
        objTop.style.top = parseInt(RT.bottom + 3) + "px";
        objTop.style.display = "block";
        document.getElementById("PPADD").style.display = "inline-block";
        document.getElementById("PPClose").style.width = "50%";
        window.ontractListOpenTab = 3;
        this._selMode = "OTHER";
    }

    /** 상대 사업자 목록 조회 (ajax) — ContractAutocomplete 와 공유(window.get_Other_DocList) */
    get_Other_DocList = (co_title) => {
        var adr = "/u/ajax/order-tax/bizforms";
        var sendData = { "getdoctype": "OTHER", "user_no": window.manager_loginnum, "co_title": co_title };
        $.ajax({
            type: "GET", url: adr, data: sendData, success: (data) => {
                var myData = data.datas;
                if (typeof (myData) != "object") myData = [];
                window.other_co_Docs = myData;
                if (window.coBoxCalTar) this.getOthereCoinfo(window.coBoxCalTar);
            }
        });
    }

    /** '추가' 버튼 → 새 사업자 등록 폼 */
    add_Subject = (no) => {
        $('#contractListSelATop').hide();
        this.make_BixForm(this._selMode, 0);
    }

    /** 기본 사업자 체크박스 토글 */
    checkdefSetBizForm = () => {
        var checkmeSet = document.getElementById("checkmeasdef").checked;
        checkmeSet == true ? document.getElementById("setmeasdefault").value = 1 : document.getElementById("setmeasdefault").value = 0;
    }

    /** 사업자 정보 연결 해제(초기화) */
    coinfosetClear = (stype) => {
        this.getMyDocInfoSet(-1, stype);
        var adr = "/u/ajax/order-tax/bizform-link";
        var sendData = { "ordernum": window.orderTax.current_ordernum, "linkbizform": 0, "linktype": 2, "targetTitle": "" };
        $.ajax({
            type: "POST", url: adr, data: sendData, success: (data) => {
                if (data.reloadContacts) window.get_mem_ContactLists(-99);
            }
        });
    }

    /** 사업자 선택 → 명세서에 정보 표시 + 오더-바이즈폼 연결 */
    getMyDocInfoSet = (refno, Stype) => {
        if (refno == undefined) refno = 0;
        refno = parseInt(refno);
        if (isNaN(refno)) refno = 0;
        var regeditcoInfo_cono = "";
        var regeditcoInfo_address = "";
        var regeditcoInfo_cotitle = "";
        var regeditcoInfo_ceoname = "";
        var regeditcoInfo_cotel = "";
        var regeditcoInfo_coperson = "";
        var regeditcoInfo_cofax = "";
        var regeditcoInfo_persontel = "";
        var thisstampurl = "";
        $('#contractListSelATop').hide();
        if (refno >= 0) {
            var GData = [];
            Stype == 1 ? GData = window.my_co_Docs : GData = window.other_co_Docs;

            if (GData.length >= refno) {
                var chit = GData[refno];
                if (typeof (chit) != "object") chit = {};
                regeditcoInfo_cono = chit.co_number;
                regeditcoInfo_address = chit.co_address;
                regeditcoInfo_cotitle = chit.co_title;
                regeditcoInfo_ceoname = chit.co_ceoname;
                regeditcoInfo_cotel = chit.co_tel;
                regeditcoInfo_coperson = chit.co_manager;
                regeditcoInfo_cofax = chit.co_fax;
                regeditcoInfo_persontel = chit.co_managertel;
                thisstampurl = chit.stamp_url;
                var rsno = parseInt(chit.rsno);
                if (isNaN(rsno)) rsno = 0;
                if (rsno > 0 && window.orderTax.current_ordernum) {
                    var target_coTitle = "";
                    if (Stype == 2) {
                        target_coTitle = document.getElementById("played_co_name").value;
                    } else {
                        document.getElementById("payed_tome_co_refno").value = rsno;
                    }
                    if (regeditcoInfo_cotitle == undefined) regeditcoInfo_cotitle = "";
                    if (document.getElementById("payed_status2").checked == true) {
                        if (regeditcoInfo_cotitle.length > 0) {
                            if (document.getElementById("paystae_where").value == "") {
                                document.getElementById("paystae_where").value = regeditcoInfo_cotitle;
                            } else {
                                if (document.getElementById("paystae_where").value != regeditcoInfo_cotitle && Stype == 2) {
                                    var nncnt = document.getElementById("paystae_where").value;
                                    var mgok = "현재 수금상태 => 수금처 가 [" + nncnt + "] 입니다.\n\n수금처를 [" + regeditcoInfo_cotitle + "]로 변경할까요?";
                                    if (confirm(mgok)) {
                                        document.getElementById("paystae_where").value = regeditcoInfo_cotitle;
                                    }
                                }
                            }
                        }
                    }

                    var adr = "/u/ajax/order-tax/bizform-link";
                    var sendData = { "ordernum": window.orderTax.current_ordernum, "linkbizform": rsno, "linktype": Stype, "targetTitle": target_coTitle, "regeditcoInfo_cotitle": regeditcoInfo_cotitle };
                    $.ajax({
                        type: "POST", url: adr, data: sendData, success: (data) => {
                            if (Stype == 2 && rsno > 0) {
                                var baljoo_bizform_co_refno = document.getElementById("baljoo_bizform_co_refno");
                                if (baljoo_bizform_co_refno) baljoo_bizform_co_refno.value = rsno;
                            }
                            if (data.reloadContacts) window.get_mem_ContactLists(-99);
                        }
                    });
                }
            }
        }
        if (Stype == 1) {
            document.getElementById("suplyer_conum").innerHTML = Util.escapeHtml(regeditcoInfo_cono);
            document.getElementById("suplyer_cotitle").innerHTML = Util.escapeHtml(regeditcoInfo_cotitle);
            document.getElementById("suplyer_ceoname").innerHTML = Util.escapeHtml(regeditcoInfo_ceoname);
            document.getElementById("suplyer_coaddress").innerHTML = Util.escapeHtml(regeditcoInfo_address);
            document.getElementById("suplyer_stamp").innerHTML = "<img src='" + thisstampurl + "' style='height:30px'>";
        } else {
            document.getElementById("reciver_cono").innerHTML = Util.escapeHtml(regeditcoInfo_cono);
            document.getElementById("reciver_coname").innerHTML = Util.escapeHtml(regeditcoInfo_cotitle);
            document.getElementById("reciver_ceoname").innerHTML = Util.escapeHtml(regeditcoInfo_ceoname);
            document.getElementById("reciver_address").innerHTML = Util.escapeHtml(regeditcoInfo_address);
        }
    }

    /** 사업자 등록/수정 폼 렌더 */
    make_BixForm = (regmd, editno, refno) => {
        if (editno == undefined) editno = 0;
        editno = parseInt(editno);
        if (isNaN(editno)) editno = 0;
        var chBoxCheck = "";
        var setmeasdefault = 0;
        var regeditcoInfo_cono = "";
        var regeditcoInfo_address = "";
        var regeditcoInfo_cotitle = "";
        var regeditcoInfo_ceoname = "";
        var regeditcoInfo_cotel = "";
        var regeditcoInfo_coperson = "";
        var regeditcoInfo_cofax = "";
        var regeditcoInfo_persontel = "";
        var regeditcoInfo_mail = "";
        var thisstampurl = "";
        var selfIs_default = "";
        $('#contractListSelATop').hide();
        if (refno >= 0) {
            var SData = [];
            regmd == "SELF" ? SData = window.my_co_Docs : SData = window.other_co_Docs;
            if (SData.length >= refno) {
                var chit = SData[refno];
                if (typeof (chit) != "object") chit = {};
                regeditcoInfo_cono = chit.co_number;
                regeditcoInfo_address = chit.co_address;
                regeditcoInfo_cotitle = chit.co_title;
                regeditcoInfo_ceoname = chit.co_ceoname;
                regeditcoInfo_cotel = chit.co_tel;
                regeditcoInfo_coperson = chit.co_manager;
                regeditcoInfo_cofax = chit.co_fax;
                regeditcoInfo_persontel = chit.co_managertel;
                thisstampurl = chit.stamp_url;
                regeditcoInfo_mail = chit.main_email;
                var is_default = parseInt(chit.is_default);
                if (regmd == "SELF") {
                    if (isNaN(is_default)) is_default = 0;
                    if (is_default == 1) {
                        selfIs_default = " checked ";
                    }
                }
            }
        }

        if (regmd == "SELF") {
            document.getElementById("Contract_DocTitle").innerHTML = "내 사업자 정보 등록";
            document.getElementById("saveBizFormBtn").innerHTML = "저장";
            if (editno > 0) {
                document.getElementById("Contract_DocTitle").innerHTML = "내 사업자 정보 수정";
                document.getElementById("saveBizFormBtn").innerHTML = "수정";
            }
            if (thisstampurl == "") {
                thisstampurl = "/img/emp.png";
            }
            chBoxCheck += "<input type='checkbox' style='height:20px; width:20px' " + selfIs_default + " id='checkmeasdef' onclick='checkdefSetBizForm()' oncchange='checkdefSetBizForm()'><label for='checkmeasdef'>&nbsp;기본 사업자로 선택하기</label>";
        } else {
            if (editno > 0) {
                document.getElementById("Contract_DocTitle").innerHTML = "<font style='color:yellow'>[" + Util.escapeHtml(regeditcoInfo_cotitle) + "]</font> 사업자 정보 수정</font>";
                document.getElementById("saveBizFormBtn").innerHTML = "수정";
            } else {
                document.getElementById("Contract_DocTitle").innerHTML = "<font style='color:#FFFFFF'>새 사업자 등록</font>";
                document.getElementById("saveBizFormBtn").innerHTML = "추가";
            }
            thisstampurl = "/img/emp.png";
        }
        var st1 = "style='border-right:1px solid #C1C1C1'";
        var st2 = "style='border-bottom:1px solid #C1C1C1'";
        var st3 = "style='border-bottom:1px solid #C1C1C1;border-top:1px solid #C1C1C1'";
        var st4 = "style='border-left:1px solid #C1C1C1;border-right:1px solid #C1C1C1; text-align:center; background-color:#FFFFFF'";
        var bst = "style='background-color:#F7F7F7' ";
        var bxt = "style='background-color:#F7F7F7; text-align:center' ";
        var bbs = ";background-color:#F7F7F7;";
        var htm = "<div style='width:90%;margin:0px auto; padding:10px 10px 0px 10px'>";
        htm += "<input type='hidden' id='cobiz_editno' value='" + editno + "'>";
        htm += "<input type='hidden' id='setmeasdefault' value='" + setmeasdefault + "'>";
        htm += "<input type='hidden' id='editreg_mode' value='" + regmd + "'>";
        htm += "<table style='width:100%;'>";
        htm += "<colgroup><col style='width:100px'/><col style='width:*%'/></colgrouup>";
        htm += "		<tr " + st3 + ">";
        htm += "			<td " + st1 + ">사업자 번호</td>";
        htm += "			<td " + bst + ">";
        if (regmd == "SELF") {
            htm += "				<table style='width:100%'>";
            htm += "					<colgroup><col style='width:*%'/><col style='width:80px'/><col style='width:80px'/></colgrouup>";
            htm += "					<tr>";
            htm += "						<td " + bst + "><input type='text' style='width:96%;height:30px; font-weight:bolder;outline:none; border:none" + bbs + "' placeHolder='사업자 번호 입력' id='regeditcoInfo_cono' value='" + Util.escapeHtml(regeditcoInfo_cono) + "'></td>";
            htm += "						<td " + st4 + ">도장</td>";
            htm += "						<td " + bxt + "><img src='" + thisstampurl + "?stnp=" + new Date() + "' style='height:25px; vertical-align:middle' id='thisFormStampImg'></td>";
            htm += "					</tr>";
            htm += "				</table>";
        } else {
            htm += "				<input type='text' style='width:96%;height:30px; font-weight:bolder;outline:none; border:none" + bbs + "' placeHolder='사업자 번호 입력' id='regeditcoInfo_cono' value='" + Util.escapeHtml(regeditcoInfo_cono) + "'>";
        }
        htm += "			</td>";
        htm += "		</tr>";

        htm += "		<tr " + st2 + ">";
        htm += "			<td " + st1 + ">사업자 상호</td>";
        htm += "			<td " + bst + ">";
        htm += "				<table style='width:100%'>";
        htm += "					<colgroup><col style='width:*%'/><col style='width:80px'/><col style='width:*%'/></colgrouup>";
        htm += "					<tr>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='상호 입력'  id='regeditcoInfo_cotitle' value='" + Util.escapeHtml(regeditcoInfo_cotitle) + "'></td>";
        htm += "						<td " + st4 + ">대표이름</td>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='대표 이름 입력'  id='regeditcoInfo_ceoname' value='" + Util.escapeHtml(regeditcoInfo_ceoname) + "'></td>";
        htm += "					</tr>";
        htm += "				</table>";
        htm += "			<td>";
        htm += "		</tr>";

        htm += "		<tr " + st2 + ">";
        htm += "			<td " + st1 + ">사업장 주소</td>";
        htm += "			<td style='text-align:center" + bbs + "'><input type='text' style='width:96%;height:30px;font-weight:normal;outline:none" + bbs + "; border:none' placeHolder='주소 입력'  id='regeditcoInfo_address' value='" + Util.escapeHtml(regeditcoInfo_address) + "'></td>";
        htm += "		</tr>";

        htm += "		<tr " + st2 + ">";
        htm += "			<td " + st1 + ">대표 번호</td>";
        htm += "			<td " + bst + ">";
        htm += "				<table style='width:100%'>";
        htm += "					<colgroup><col style='width:*%'/><col style='width:80px'/><col style='width:*%'/></colgrouup>";
        htm += "					<tr>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='대표 번호 입력'  id='regeditcoInfo_cotel' value='" + Util.escapeHtml(regeditcoInfo_cotel) + "'></td>";
        htm += "						<td " + st4 + ">담당자명</td>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='담당자 입력'  id='regeditcoInfo_coperson' value='" + Util.escapeHtml(regeditcoInfo_coperson) + "'></td>";
        htm += "					</tr>";
        htm += "				</table>";
        htm += "			<td>";
        htm += "		</tr>";
        if (regmd == "SELF") {
            htm += "	<input type='hidden' id='main_email' value=''>";
        } else {
            htm += "		<tr " + st2 + ">";
            htm += "			<td " + st1 + ">메일 주소</td>";
            htm += "			<td style='text-align:center" + bbs + "'><input type='text' style='width:96%;height:30px;font-weight:normal;outline:none" + bbs + "; border:none' placeHolder='세금계산서를 받을 메일주소'  id='main_email' value='" + Util.escapeHtml(regeditcoInfo_mail) + "'></td>";
            htm += "		</tr>";
        }
        htm += "		<tr " + st2 + ">";
        htm += "			<td " + st1 + ">팩스 번호</td>";
        htm += "			<td " + bst + ">";
        htm += "				<table style='width:100%'>";
        htm += "					<colgroup><col style='width:*%'/><col style='width:80px'/><col style='width:*%'/></colgrouup>";
        htm += "					<tr>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='팩스 번호 입력'  id='regeditcoInfo_cofax' value='" + Util.escapeHtml(regeditcoInfo_cofax) + "'></td>";
        htm += "						<td " + st4 + ">담당연락처</td>";
        htm += "						<td " + bst + "><input type='text' style='width:100%;height:30px;font-weight:normal;outline:none; border:none" + bbs + "' placeHolder='담당자 연락처'  id='regeditcoInfo_persontel' value='" + Util.escapeHtml(regeditcoInfo_persontel) + "'></td>";
        htm += "					</tr>";
        htm += "				</table>";
        htm += "			</td>";
        htm += "		</tr>";
        htm += "		<tr>";

        var mga1 = "상호 , 사업자 번호 중 하나이상 정보입력<br>";
        htm += "			<td colspan=2 style='text-align:right; line-height:20px'>" + chBoxCheck + "</td>";
        htm += "		</tr>";
        htm += "</table>";
        htm += "</div>";
        htm += "<div style='line-height:20px;text-align:center; width:100%;'>" + mga1 + "</div>";

        var objTop = document.getElementById("Contract_DocTop");
        var obj = document.getElementById("Contract_DocCont");
        var detailLists = document.getElementById("detailLists");
        var RT = detailLists.getBoundingClientRect();
        var XX = RT.left + (RT.width - 750);
        var YY = RT.top + 200;
        obj.innerHTML = htm;
        objTop.style.width = "500px";
        objTop.style.top = YY + "px";
        objTop.style.left = XX + "px";
        objTop.style.display = "block";
    }

    /** 사업자 정보 저장 (ajax) */
    SaveCoDoc = () => {
        var regeditcoInfo_cono = parseInt(document.getElementById("cobiz_editno").value);
        if (isNaN(regeditcoInfo_cono)) regeditcoInfo_cono = 0;
        window.manager_loginnum = parseInt(window.manager_loginnum);
        if (isNaN(window.manager_loginnum)) window.manager_loginnum = 0;
        var editreg_mode = document.getElementById("editreg_mode").value;
        if ((editreg_mode != "SELF" && editreg_mode != "OTHER") || window.manager_loginnum < 9) { Util.swalert("저장 대상 정보가 없습니다."); return; }
        var co_number = document.getElementById("regeditcoInfo_cono").value;
        var co_address = document.getElementById("regeditcoInfo_address").value;
        var co_title = document.getElementById("regeditcoInfo_cotitle").value;
        var co_ceoname = document.getElementById("regeditcoInfo_ceoname").value;
        var co_tel = document.getElementById("regeditcoInfo_cotel").value;
        var co_manager = document.getElementById("regeditcoInfo_coperson").value;
        var co_fax = document.getElementById("regeditcoInfo_cofax").value;
        var co_managertel = document.getElementById("regeditcoInfo_persontel").value;
        var setmeasdefval = document.getElementById("setmeasdefault").value;
        var main_email = document.getElementById("main_email").value;

        if (co_manager.length < 2 && co_number.length < 7 && co_title.length < 2 && co_ceoname.length < 2) {
            Util.swalert("사업자번호 또는 상호 중 최소 하나이상 입력해 주세요"); return;
        }
        if (co_number.length < 7) co_number = "000-00-00000";

        var adr = "/u/ajax/order-tax/bizform";
        var sendData = {};
        sendData["regeditcoInfo_cono"] = regeditcoInfo_cono;
        sendData["co_number"] = co_number;
        sendData["co_address"] = co_address;
        sendData["co_title"] = co_title;
        sendData["co_ceoname"] = co_ceoname;
        sendData["co_tel"] = co_tel;
        sendData["co_manager"] = co_manager;
        sendData["co_fax"] = co_fax;
        sendData["co_managertel"] = co_managertel;
        sendData["manager_loginnum"] = window.manager_loginnum;
        sendData["coBizSelMode"] = editreg_mode;
        sendData["setmeasdefval"] = setmeasdefval;
        sendData["main_email"] = main_email;
        $.ajax({
            type: "POST", url: adr, data: sendData, success: (data) => {
                if (data.result == true) {
                    window.coBoxCalTar = null;
                    if (editreg_mode == "SELF") this.get_myCo_DocList("");
                    if (editreg_mode == "OTHER") this.get_Other_DocList("");
                    if (regeditcoInfo_cono > 0) {
                        Util.swalert(['수정완료', 'success']);
                    } else {
                        Util.swalert(['등록완료', 'success']);
                    }
                    $('#Contract_DocTop').hide();
                } else {
                    Util.swalert(data.error);
                    return;
                }
            }
        });
    }

    // ─────────────────────────────── 2) 폰트 설정 ───────────────────────────────

    fontSetDig = () => {
        var currentfontname = String(document.getElementById("currentfontname").value);
        var currentfontsize = String(document.getElementById("currentfontsize").value);
        var fonts = "돋움|돋움체|맑은 고딕|굴림|굴림체|바탕|바탕체|Verdana|휴먼엽서체|Andale Mono|Arial|Arial Narrow|Bookman Old Style|Copperlate Gothic|Lucida Blackletter|MS Sans Serif".split("|");
        var sizes = "10 11 12 13 14 15 16 17 18 19 20".split(" ");

        function chips(items, cur, fn, suffix) {
            var h = "";
            for (var i = 0; i < items.length; i++) {
                var on = (String(items[i]) === String(cur)) ? " on" : "";
                h += "<button type='button' class='fs-chip" + on + "' onclick=\"" + fn + "(this)\">" + items[i] + (suffix || "") + "</button>";
            }
            return h;
        }

        var htm = ""
            + "<div class='fs-wrap'>"
            + "<div class='fs-sec'>"
            + "<div class='fs-sec-head'><span class='fs-sec-title'>폰트</span>"
            + "<span class='fs-cur' id='currentfontnamediv' dataval=\"" + currentfontname + "\">" + currentfontname + "</span></div>"
            + "<div class='fs-chips'>" + chips(fonts, currentfontname, "selFontname", "") + "</div>"
            + "</div>"
            + "<div class='fs-sec'>"
            + "<div class='fs-sec-head'><span class='fs-sec-title'>크기</span>"
            + "<span class='fs-cur' id='currentfontsizediv' dataval=\"" + currentfontsize + "\">" + currentfontsize + "px</span></div>"
            + "<div class='fs-chips'>" + chips(sizes, currentfontsize, "selFontsize", "px") + "</div>"
            + "</div>"
            + "<div class='fs-actions'>"
            + "<button type='button' class='fs-btn fs-cancel' onclick=\"$j.Ui.JBModal.close('fontset-modal')\">취소</button>"
            + "<button type='button' class='fs-btn fs-save' onclick='saveFontSet()'>저장</button>"
            + "</div>"
            + "</div>";

        $j.Ui.JBModal.html('fontset-modal', htm, '폰트 설정하기');
    }

    // 칩 클릭 → 현재값 갱신 + 같은 그룹에서 active 토글
    fsSelect = (el, curId, suffix) => {
        var val = el.textContent.replace(/px$/, '');
        var obj = document.getElementById(curId);
        obj.setAttribute("dataval", val);
        obj.innerHTML = val + (suffix || "");
        var group = el.parentNode.getElementsByClassName("fs-chip");
        for (var i = 0; i < group.length; i++) group[i].classList.remove("on");
        el.classList.add("on");
    }

    selFontname = (el) => { this.fsSelect(el, "currentfontnamediv", ""); }
    selFontsize = (el) => { this.fsSelect(el, "currentfontsizediv", "px"); }

    saveFontSet = () => {
        var f_name = document.getElementById("currentfontnamediv").getAttribute("dataval");
        var f_Size = document.getElementById("currentfontsizediv").getAttribute("dataval");

        // 폰트 쿠키를 path=/ 로 1년 저장(= /u/orders 의 OrderListController 가 읽음) 후 목록으로 이동.
        // 이름은 PHP 상수 G5_COOKIE_PC_FONT/FSIZE 와 같은 문자열(경계쿠키). Store 가 encode → PHP 가 auto-decode.
        $j.Common.Store.cookie.set("jbuser2000_PCFont", f_name, { days: 365 });
        $j.Common.Store.cookie.set("jbuser2000_PCFsize", f_Size, { days: 365 });
        location.replace("/u/orders");
    }

    // ─────────────────────────────── 3) 거래명세서 내보내기 ───────────────────────────────

    exportContract = (act) => {
        var popwinOrdernum = Util.int(document.getElementById("popwinOrdernum").value);
        var current_billprintst = Util.int(document.getElementById("current_billprintst").value);
        var current_texnum = Util.int(document.getElementById("current_texnum").value);
        var is_related_contract = Util.int(document.getElementById("is_related_contract").value);
        var multi_print_cnt = Util.int(document.getElementById("multi_print_cnt").value);
        var seldordertypestr = document.getElementById("seldordertypestr").value;
        var billprintstStr = document.getElementById("billprintstStr").value;
        if (is_related_contract == 1) billprintstStr = "상대거래";
        var reciver_coname = document.getElementById("reciver_coname").innerHTML;
        if (document.getElementById("billstatus_5").checked == true) return;

        var baljoo_bizform_co_refno = Util.int(document.getElementById("baljoo_bizform_co_refno").value);
        if (baljoo_bizform_co_refno < 1) { Util.swalert("상대방(공급받는자) 값이 없습니다."); return; }
        var last_priceonbill, multiFormTd_sprice;
        if (document.getElementById("multiFormTd_after")) {
            last_priceonbill = Util.int(document.getElementById("multiFormTd_after").innerHTML);
            multiFormTd_sprice = document.getElementById("multiFormTd_sprice").innerHTML;
        } else {
            last_priceonbill = Util.int(document.getElementById("car_basepricevaluein").value);
            multiFormTd_sprice = Util.int(document.getElementById("thisCarorginprice").value);
        }
        var bal_print_tax_refstr = document.getElementById("bal_print_tax_refstr").value;
        if (current_texnum < 2 || current_billprintst < 1) {
            Util.swalert("세금계산 , 수금상태 설정 후 저장을 먼저해 주세요\n\n저장 후 라면 내보낼 오더를 리스트에서 다시 선택해 주세요"); return;
        }
        if (popwinOrdernum < 2) { Util.swalert("해당 오더가 없거나 에러 입니다."); return; }
        var obj = document.getElementById("popBizHeadVal");
        var inputs = obj.getElementsByTagName("TR");
        var htmlString = "";
        var div = document.createElement('TABLE');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].getAttribute("trtype") == "multiline") {
            }
        }
        var coInfo = document.getElementById("reciver_cono").innerHTML;
        coInfo += "`" + document.getElementById("reciver_coname").innerHTML;
        coInfo += "`" + document.getElementById("reciver_ceoname").innerHTML;
        coInfo += "`" + document.getElementById("reciver_address").innerHTML;
        coInfo += "`" + document.getElementById("reciver_uptae").innerHTML;
        coInfo += "`" + document.getElementById("reciver_jongmok").innerHTML;

        coInfo += "`" + document.getElementById("reciver_mail").value;
        coInfo += "`" + document.getElementById("reciver_tel").value;
        coInfo += "`" + document.getElementById("reciver_fax").value;
        coInfo += "`" + document.getElementById("reciver_person").value;

        coInfo += "`" + document.getElementById("suplyer_conum").innerHTML;
        coInfo += "`" + document.getElementById("suplyer_cotitle").innerHTML;
        coInfo += "`" + document.getElementById("suplyer_ceoname").innerHTML;
        coInfo += "`" + document.getElementById("suplyer_coaddress").innerHTML;
        coInfo += "`" + document.getElementById("suplyer_uptae").innerHTML;
        coInfo += "`" + document.getElementById("suplyer_jongmok").innerHTML;

        coInfo += "`" + document.getElementById("suplyer_mail").value;
        coInfo += "`" + document.getElementById("suplyer_tel").value;
        coInfo += "`" + document.getElementById("suplyer_fax").value;
        coInfo += "`" + document.getElementById("suplyer_person").value;
        coInfo += "`" + document.getElementById("baljoo_bizform_co_refno").value;
        coInfo += "`" + document.getElementById("payed_tome_co_refno").value;
        var StampUrl = "";
        var abstampme = document.getElementById("abstampme");
        if (abstampme) StampUrl = abstampme.getAttribute("data_src");
        if (StampUrl == undefined || StampUrl == null) StampUrl = "";
        coInfo += "`" + StampUrl;
        coInfo += "`" + multiFormTd_sprice;
        coInfo += "`" + last_priceonbill;
        coInfo += "`" + document.getElementById("totalTax").value;
        coInfo += "`" + document.getElementById("thismemberno").value + "-" + document.getElementById("popwinOrdernum").value;

        var adr = "/u/ajax/order-tax/save-contract";
        var sendData = { "refordernum": popwinOrdernum, "reftaxnum": current_texnum, "current_billprintst": current_billprintst, "billprintstStr": billprintstStr, "multi_print_cnt": multi_print_cnt, "target_conum": baljoo_bizform_co_refno, "target_cotitle": reciver_coname, "last_priceonbill": last_priceonbill, "work_step": act, "bal_print_tax_refstr": bal_print_tax_refstr, "coInfo": coInfo };
        $.ajax({
            type: "POST", url: adr, data: sendData, success: (data) => {
                var chconfirm = data.chconfirm;
                var row_cnt = parseInt(data.row_cnt);
                var havetoconfirm = parseInt(data.havetoconfirm);
                if (havetoconfirm == 1 && chconfirm.length > 5) {
                    var ss = chconfirm.split("|");
                    var mgg = ss[1];
                    Util.swalert([mgg, 'question'], () => {
                        this.exportContract("ok");
                    }, ['네', '아니오']);
                } else if (chconfirm == "No data") {
                    Util.swalert("저장된 거래명세서가 없습니다.\n\n거래명세서를 먼저 저장 후 내보내기 실행해 주세요");
                    return;
                }
            }
        });
    }
}
